import { render, staticRenderFns } from "./PayServiceInfo.vue?vue&type=template&id=0d7531f4&scoped=true&"
import script from "./PayServiceInfo.vue?vue&type=script&lang=ts&"
export * from "./PayServiceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PayServiceInfo.vue?vue&type=style&index=0&id=0d7531f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7531f4",
  null
  
)

export default component.exports